import { SEARCH_SHIPMENT_FAILURE, SEARCH_SHIPMENT_REQUEST, SEARCH_SHIPMENT_REST, SEARCH_SHIPMENT_SUCCESS } from "../../actions";
const initialState = {
    fetchShipments: null,
    isLoading: false,
    error: null,
};
const searchShipmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEARCH_SHIPMENT_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null });
        case SEARCH_SHIPMENT_SUCCESS:
            return Object.assign(Object.assign({}, state), { fetchShipments: action.payload, isLoading: false, error: null });
        case SEARCH_SHIPMENT_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case SEARCH_SHIPMENT_REST:
            return initialState;
        default:
            return state;
    }
};
export default searchShipmentReducer;
